<template>
	<div class="gap column content">
		<header class="row centering separated">
			<router-link class="rigid" to="/payments"><i class="fas fa-arrow-left"></i></router-link>
			<h1 v-if="nextPayment" class="rigid">Next Payment</h1>
			<h1 v-else class="rigid">No Scheduled Payment</h1>
		</header>
		<receipt-view v-if="nextPayment" :receipt="nextPayment"></receipt-view>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReceiptView from '@/components/ReceiptView.vue';

export default {
	name: 'NextPayment',
	components: {
		ReceiptView
	},
	computed: {
		...mapGetters([
			'account'
		]),
		nextPayment() {
			return this.account && this.account.nextPayment;
		}
	}
};

</script>



// WEBPACK FOOTER //
// ./src/views/NextPayment.vue